<template>
  <v-tooltip :disabled="!truncate" top>
    <template v-slot:activator="{ on: tooltip }">
      <span
        class="d-inline-block text-truncate"
        :style="'max-width: '+width+'px;'"
        v-on="{ ...tooltip }"
        @dblclick="dbclick"
      >
        {{value}}
      </span>
    </template>
    <span>{{value}}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'DocumentName',
  props: {
    value: {
      type: String
    },
    width: {
      type: String
    }
  },
  computed: {
    truncate() {
      return this.value.length > (+this.width/8) 
    }
  },
  methods: {
    dbclick() {
      this.$emit('dbclick')
    }
  }
}
</script>